// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text_Xzz7xePH {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-wrap: nowrap;\n}\n", "",{"version":3,"sources":["webpack://./public/views/common/VueComponents/table/cells/less/textCell.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,uBAAA;EACA,iBAAA;AACF","sourcesContent":[".text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-wrap: nowrap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": "text_Xzz7xePH"
};
export default ___CSS_LOADER_EXPORT___;
